module.exports = __webpack_public_path__ + "static/media/NotoSansTC-Regular.8b347901.otf";